import * as React from "react";

import BiddingOwl from "assets/icons/bidding/owlOverlay.png";
import CloseIcon from "assets/icons/close.svg";

import "./styles.scss";

interface SummaryOverlayProps {
  htmlContent: string;
  onHide: () => void;
  show: boolean;
  title?: string;
}

const SummaryOverlay = ({ htmlContent, show, onHide, title }: SummaryOverlayProps) => {
  if (!show) return null;

  return (
    <div className="summary-overlay-wrapper">
      <div className="summary-overlay-content">
        <div>
          <div className="header-summary-overlay">
            <span>
              כל הזכויות שמורות ל GoBeB. אין להעתיק, לצלם, לשדר / לקלוט בכל אמצעי או לעשות כל שימוש
              מסחרי בחומרים הכלולים באתר
            </span>
            <img src={CloseIcon} onClick={onHide} alt="close" />
          </div>
          <h2 className="title-summary-overlay">{title}</h2>
          <div className="container-summary-overlay">
            <div className="summary-overlay-image">
              <img src={BiddingOwl} alt="owl" />
            </div>
            <div
              className="content-summary-overlay"
              dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
            <div className="opacity-text-privacy"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryOverlay;
